import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {catchError} from "rxjs/operators";
import {TriggerStatementsComponent} from "./trigger-statements/trigger-statements.component";

@Injectable()
export class StatementsService {

  private statementsUrl: string;

  constructor(private http: HttpClient) {
    this.statementsUrl = window.location.protocol + "//" + window.location.hostname + "/statements";
  }

  public trigger(form: TriggerStatementsComponent) {
    return this.http.get(this.statementsUrl, { responseType: 'text'}).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

}



// WEBPACK FOOTER //
// ./src/app/statements-service.service.ts